const members = [
  {
    name: "Mohit Valecha",
    position: "Founder",
    desc: "Founder",
    src:"/MohitValecha.jpg"
  },
  {
    name: "Devi Valecha",
    position: "Founder",
    desc: "",
    src:"/DeviValecha.jpg"
  },
  {
    name: "Priti Doppa",
    position: "Hr",
    desc: "",
    src:"/PritiDoppa.jpg"
  },
  {
    name: "Swaranjali Sutar",
    position: "DevOps Engineer",
    desc: "",
    src:"/SwaraSutar.jpg"
  },
  {
    name: "Ekansh Lohabare",
    position: "Wordpress Developer",
    desc: "",
    src:"/Ekansh.jpg"
  },
  {
    name: "Arti Nhalve",
    position: "Frontend Developer",
    desc: "",
    src:"/Arti.jpg"
  },
  {
    name: "Ranjan Mahto",
    position: "Python Developer",
    desc: "",
    src:"/Ranjan.jpg"
  },
  {
    name: "Vishal Yadav",
    position: "Front-End Developer",
    desc: "Creative Web Developer",
    src:"/Vishal.jpg"
  },
  {
    name: "Mishty Vidhani",
    position: "UX & Graphics Designer",
    desc: "",
    src:"/MistyVidhani.jpg"
  },
  {
    name: "Prathamesh Narkhede",
    position: "Back-End Developer",
    desc: "",
    src:"/Prathamesh.jpg"
  },
  {
    name: "Madhura Powar",
    position: "Java Developer",
    desc: "",
    src:"/Madhura.jpg"
  },
  {
    name: "Anushka Hatwar",
    position: "Website",
    desc: "",
    src:"/Anushka.jpeg"
  },
];
export default members;
